import { ColumnId } from '@/types';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface TableStore {
    visibleColumns: ColumnId[];
    setVisibleColumns: (columns: ColumnId[]) => void;
    toggleColumn: (columnId: ColumnId) => void;
}

const DEFAULT_COLUMNS: ColumnId[] = [
    'photo',
    'name',
    'brewery',
    'style',
    'untappd',
    'packaging_type',
    'volume',
    'props',
    'price',
    'actions',
];

export const useTableStore = create<TableStore>()(
    persist(
        (set) => ({
            visibleColumns: DEFAULT_COLUMNS,

            setVisibleColumns: (columns) => set({ visibleColumns: columns }),

            toggleColumn: (columnId) =>
                set((state) => ({
                    visibleColumns: state.visibleColumns.includes(columnId)
                        ? state.visibleColumns.filter((id) => id !== columnId)
                        : [...state.visibleColumns, columnId],
                })),
        }),
        {
            name: 'beer_dealer_table_state',
            storage: createJSONStorage(() => localStorage),
        },
    ),
);
